module.exports = __webpack_public_path__ + "static/media/BlackDrownin.bdf7a5e9.jpg";